<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/ccdszuzhitop.png" class="img" />
        <!-- <div class="wait">敬请期待...</div> -->
        <img src="../../assets/images/zuzhititle1.png" class="zuzhititleimg" />
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会名誉主席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">方&nbsp;&nbsp;&nbsp;&nbsp;方</div>
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;航</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会主席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">吴文育</div>
                <div class="name">汤依晨</div>
            </div>
        </div>

        <!-- <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会执行主席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">陈爱军</div>
            </div>
        </div> -->

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">副主席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">陈晓栋</div>
                <div class="name">万苗坚</div>
                <div class="name">王&nbsp;&nbsp;&nbsp;&nbsp;焱</div>
                <div class="name">于&nbsp;&nbsp;&nbsp;&nbsp;波</div>
                <div class="name">陈淑君</div>
                <div class="name">布文博</div>
                <div class="name">何仁亮</div>
                <div class="name">赵敬军</div>
                <div class="name">栾&nbsp;&nbsp;&nbsp;&nbsp;菁</div>
                <div class="name">陈裕充</div>
                <div class="name">赖永贤</div>
                <div class="name">林尽染</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会秘书长</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">陈淑君</div>
                <div class="name">布文博</div>
            </div>
        </div>

        <!-- <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会发言人</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">樊一斌</div>
            </div>
        </div> -->

        <!-- <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">秘书处</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">李&nbsp;&nbsp;&nbsp;&nbsp;勇</div>
                <div class="name">宁晓明</div>
                <div class="name">齐&nbsp;&nbsp;&nbsp;&nbsp;盼</div>
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;岷</div>
                <div class="name">陈伟文</div>
            </div>
        </div> -->

        <img src="../../assets/images/zuzhititle2.png" class="zuzhititleimg1" />
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">主&nbsp;&nbsp;&nbsp;&nbsp;席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">陈晓栋</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">委&nbsp;&nbsp;&nbsp;&nbsp;员</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">汤依晨</div>
                <div class="name">栾&nbsp;&nbsp;&nbsp;&nbsp;菁</div>
                <div class="name">陈淑君</div>
                <div class="name">布文博</div>
                <div class="name">赵&nbsp;&nbsp;&nbsp;&nbsp;爽</div>
                <div class="name">程传涛</div>
                <div class="name">陈裕充</div>
                <div class="name">赖永贤</div>
                <div class="name">林尽染</div>
                <div class="name">龚轶一</div>
                <div class="name">朱沁媛</div>
                <div class="name">刘建兰</div>
                <div class="name">任&nbsp;&nbsp;&nbsp;&nbsp;捷</div>
            </div>
        </div>

        <!-- <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">学术秘书组</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">杜&nbsp;&nbsp;&nbsp;&nbsp;娟</div>
                <div class="name">于&nbsp;&nbsp;&nbsp;&nbsp;倩</div>
            </div>
        </div> -->

        <img src="../../assets/images/zuzhititle3.png" class="zuzhititleimg1" />
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">主&nbsp;&nbsp;&nbsp;&nbsp;席</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">吴文育</div>
            </div>
        </div>

        <div class="model1">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">委&nbsp;&nbsp;&nbsp;&nbsp;员</div>
                    <div class="PinyinSorting">按姓氏拼音排序</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">艾&nbsp;&nbsp;&nbsp;&nbsp;勇</div>
                <div class="name">蔡大幸</div>
                <div class="name">蔡&nbsp;&nbsp;&nbsp;&nbsp;涛</div>
                <div class="name">陈&nbsp;&nbsp;&nbsp;&nbsp;骏</div>
                <div class="name">陈向东</div>
                <div class="name">陈&nbsp;&nbsp;&nbsp;&nbsp;瑶</div>
                <div class="name">陈&nbsp;&nbsp;&nbsp;&nbsp;勇</div>
                <div class="name">程传涛</div>
                <div class="name">崔儒涛</div>
                <div class="name">戴耕武</div>
                <div class="name">党宁宁</div>
                <div class="name">邓成成</div>
                <div class="name">邓&nbsp;&nbsp;&nbsp;&nbsp;丹</div>
                <div class="name">邓&nbsp;&nbsp;&nbsp;&nbsp;辉</div>
                <div class="name">邓&nbsp;&nbsp;&nbsp;&nbsp;军</div>
                <div class="name">翟建新</div>
                <div class="name">傅&nbsp;&nbsp;&nbsp;&nbsp;强</div>
                <div class="name">高贵云</div>
                <div class="name">高金平</div>
                <div class="name">葛一平</div>
                <div class="name">郭&nbsp;&nbsp;&nbsp;&nbsp;昊</div>
                <div class="name">郭伟楠</div>
                <div class="name">何&nbsp;&nbsp;&nbsp;&nbsp;平</div>
                <div class="name">何仁亮</div>
                <div class="name">何&nbsp;&nbsp;&nbsp;&nbsp;玉</div>
                <div class="name">花&nbsp;&nbsp;&nbsp;&nbsp;卉</div>
                <div class="name">纪明开</div>
                <div class="name">简杏玲</div>
                <div class="name">焦&nbsp;&nbsp;&nbsp;&nbsp;敬</div>
                <div class="name">康&nbsp;&nbsp;&nbsp;&nbsp;旭</div>
                <div class="name">李连楚</div>
                <div class="name">李艳玲</div>
                <div class="name">林萍萍</div>
                <div class="name">刘建兰</div>
                <div class="name">刘孟国</div>
                <div class="name">卢&nbsp;&nbsp;&nbsp;&nbsp;忠</div>
                <div class="name">马&nbsp;&nbsp;&nbsp;&nbsp;寒</div>
                <div class="name">彭建中</div>
                <div class="name">皮龙泉</div>
                <div class="name">乔建军</div>
                <div class="name">沈聪聪</div>
                <div class="name">石祥广</div>
                <div class="name">宋&nbsp;&nbsp;&nbsp;&nbsp;丹</div>
                <div class="name">谭宣丰</div>
                <div class="name">汤&nbsp;&nbsp;&nbsp;&nbsp;諹</div>
                <div class="name">陶&nbsp;&nbsp;&nbsp;&nbsp;娟</div>
                <div class="name">万春雷</div>
                <div class="name">万苗坚</div>
                <div class="name">万学峰</div>
                <div class="name">王大光</div>
                <div class="name">王&nbsp;&nbsp;&nbsp;&nbsp;敬</div>
                <div class="name">王上上</div>
                <div class="name">王&nbsp;&nbsp;&nbsp;&nbsp;伟</div>
                <div class="name">王秀丽</div>
                <div class="name">王&nbsp;&nbsp;&nbsp;&nbsp;焱</div>
                <div class="name">文昌晖</div>
                <div class="name">文&nbsp;&nbsp;&nbsp;&nbsp;翔</div>
                <div class="name">吴晓琰</div>
                <div class="name">邢卫斌</div>
                <div class="name">许雪珠</div>
                <div class="name">薛斯亮</div>
                <div class="name">杨镓宁</div>
                <div class="name">杨&nbsp;&nbsp;&nbsp;&nbsp;凯</div>
                <div class="name">杨&nbsp;&nbsp;&nbsp;&nbsp;柳</div>
                <div class="name">杨淑霞</div>
                <div class="name">姚春丽</div>
                <div class="name">姚晓东</div>
                <div class="name">于&nbsp;&nbsp;&nbsp;&nbsp;波</div>
                <div class="name">于&nbsp;&nbsp;&nbsp;&nbsp;培</div>
                <div class="name">詹济滂</div>
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;斌</div>
                <div class="name">张东晨</div>
                <div class="name">张广亮</div>
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;健</div>
                <div class="name">张江林</div>
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;良</div>
                <div class="name">张维娜</div>
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;雪</div>
                <div class="name">赵敬军</div>
                <div class="name">赵&nbsp;&nbsp;&nbsp;&nbsp;爽</div>
                <div class="name">赵&nbsp;&nbsp;&nbsp;&nbsp;涛</div>
                <div class="name">钟剑波</div>
                <div class="name">周&nbsp;&nbsp;&nbsp;&nbsp;武</div>
                <div class="name">朱定衡</div>
            </div>
        </div>

        <div class="footer">
            <!-- 按姓氏拼音排序 -->
        </div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'zuzhi',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initccdsShare();
        document.title = "CCDS第四届中国皮肤外科大会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    position: relative;
    border-bottom: 1px solid rgb(0, 53, 133);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.PinyinSorting {
    position: absolute;
    font-size: 12px;
    top: 9px;
    left: 40%;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: .3rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 14.28%;
    text-align: center;
    font-size: .35rem;
    margin: 0.1rem 0;
}

.footer {
    width: 92%;
    margin: 0.3rem auto 0.5rem;
    text-align: right;
    font-size: .3rem;
    border-bottom: 0.5rem solid rgb(0, 53, 133);
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    padding-top: 20%;
}
</style>